// DO NOT EDIT this file was generated with scripts/IntrinsicElements
import * as React from "react";

export interface FuroVerticalFlex extends React.HTMLAttributes<HTMLElement> {
  "onscroll-down"?: (d: CustomEvent) => void;
  "onscroll-up"?: (d: CustomEvent) => void;
  // properties

  // attributes
  // no attributes defined.
}

declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      /**
       *
       * ### Overview
       *
       * Use this to arrange your content vertically.
       *
       * ### Usage
       *
       * The Elements you place inside the default slot can have the following attributes:
       *
       * - <b>flex</b>: Makes the element use the "rest" of the space (flex: 1).
       * - <b>scroll</b>: Makes the element scrollable.
       * - <b>padding-inline</b>: Applies inline padding.
       *
       *
       * ### Component Import
       * `import "@furo/layout/dist/VerticalFlex.js";`
       */
      "furo-vertical-flex": FuroVerticalFlex;
    }
  }
}
